module.exports = __webpack_public_path__ + "static/media/caret-left.fd9384c1.svg";